export interface IIsStrongPasswordResult {
    minLength: boolean;
    minOneNumber: boolean;
    minOneUppercase: boolean;
    minOneLowercase: boolean;
    minOneSpecial: boolean;
    isStrongPassword: boolean;
}

export const ALLOWED_SPECIAL_CHARS = "-_!@#$%^&*";
export const PWD_MIN_LENGTH = 8;

export const isStrongPassword = (password: string) => {
    const MIN_ONE_NUMBER = /.*[0-9].*/;
    const MIN_ONE_UPPERCASE = /.*[A-Z].*/;
    const MIN_ONE_LOWERCASE = /.*[a-z].*/;
    const MIN_ONE_SPECIAL = /.*[!@#$%^&*].*/;
    const MIN_LENGTH = PWD_MIN_LENGTH;

    const isStrongPassword =
        password.length >= MIN_LENGTH &&
        MIN_ONE_NUMBER.test(password) &&
        MIN_ONE_UPPERCASE.test(password) &&
        MIN_ONE_LOWERCASE.test(password) &&
        MIN_ONE_SPECIAL.test(password);

    return {
        minLength: password.length >= MIN_LENGTH,
        minOneNumber: MIN_ONE_NUMBER.test(password),
        minOneUppercase: MIN_ONE_UPPERCASE.test(password),
        minOneLowercase: MIN_ONE_LOWERCASE.test(password),
        minOneSpecial: MIN_ONE_SPECIAL.test(password),
        isStrongPassword
    };
};
